<template>
  <!-- <div class="layout-box" v-if="isPermiss"> -->
  <div class="layout-box">
    <router-view></router-view>
    <div class="footer">
      <div><a class="ignore-footer-href" href="https://beian.miit.gov.cn " target="_blank"
          rel="noopener noreferrer">浙ICP备2024124820号-1</a>
        <a class="ignore-footer-href2" href="https://beian.mps.gov.cn/#/query/webSearch?code=33010602014067" target="_blank" rel="noopener noreferrer"><img
            src="@/assets/images/beian.png" alt="">
          <div>浙公网安备33010602014067号</div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {},
  computed: {
    details() {
      return this.$store.state.details;
    }
  },
  watch: {
    "details.status": {
      handler(val) {
        if (val == "hidden") {
          this.isPermiss = false;
          window.location.replace("./404.html");
        } else if (val == "normal") {
          this.isPermiss = true;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      isPermiss: false
    };
  },
  methods: {},
  created() {
    const path = this.$route.name;
    // console.log(path,1)
    // console.log(2)
    if (path == 'EntranceMobile' || path == 'Entrance' || path == 'departedList') {
      this.isPermiss = true
    } else {
      if (!this.$route.query.id) {
        // this.$router.replace({
        //   name: "EntranceMobile",
        //   query: {}
        // });
        this.$router.replace({
          name: "Entrance",
          query: {}
        });
      }

    }
  },
  mounted() {

  }
};
</script>
<style lang="less" scoped>
.footer {
  position: fixed;
  bottom: 0;
  // text-align: right;
  padding-right: 60px;
  justify-content: flex-end;
  z-index: 999;
  right: 10px;

  .ignore-footer-href {
    // width: 190px;
    font-size: 12px;
    padding: 5px 0;
    color: #01c2ff;
    display: block;
    padding-left: 30px;
  }

  .ignore-footer-href2 {
    // width: 190px;
    font-size: 12px;
    padding-bottom: 20px;
    color: #01c2ff;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }


}
</style>
